import React from 'react';
import Cal from "@calcom/embed-react";
import { X } from 'lucide-react';
import { services } from '@/mock';
import { useState, useEffect } from "react";

export const Calendar = ({ isOpen, onClose, formData }) => {
  const [selectedService, setSelectedService] = useState(formData.service);
  useEffect(() => {
    setSelectedService(formData.service);
  }, [formData.service]);

  console.log("Calendar Component - Selected Service:", selectedService);
  if (!isOpen) return null;

  // Preparamos los parámetros (incluyendo theme=dark para asegurar)
  const params = new URLSearchParams({
    name: formData?.name || "", 
    email: formData?.email || "",
    attendeePhoneNumber: formData?.phone || "",
    Auto: `${formData?.vehicleYear}-${formData?.vehicleMake}-${formData?.vehicleModel}`,
    notes: formData?.message || "",
    theme: "dark" // <--- Importante: Forzamos el tema en la URL
  }).toString();

  

  return (
    // FONDO (Overlay)
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4">
      
      {/* CAJA DEL MODAL (Estilo Oscuro) */}
      <div className="bg-neutral-900 w-full max-w-4xl h-[80vh] rounded-2xl overflow-hidden relative shadow-2xl border border-neutral-800 animate-in fade-in zoom-in duration-300">
        
        {/* BOTÓN CERRAR (Estilo Oscuro) */}
        <button 
          onClick={onClose}
          className="absolute top-4 right-4 z-50 p-2 text-neutral-400 hover:text-white hover:bg-neutral-800 rounded-lg transition-colors"
        >
          <X className="w-6 h-6" />
        </button>

        {/* COMPONENTE CAL.COM */}
        <Cal
          calLink={`k-a-solutions-1xhxe7/${selectedService}?${params}`} 
          style={{ width: "100%", height: "100%", overflow: "auto" }}
          config={{
            layout: "month_view",
            theme: "dark",
          }}
        />
      </div>
    </div>
  );
};